import request from '@/utils/request'

// 获取点位设备列表
export const getDeviceList = (data) => {
    return request({
        url: '/HVAC/heat_meter/lists',
        params: data
    })
}

// 设备点位信息-修改
export const editDeviceInfo = (data) => {
    return request({
        url: '/HVAC/heat_meter/manage',
        method: 'PUT',
        data
    })
}

// 设备点位-添加
export const addIMEI = (data) => {
    return request({
        url: '/HVAC/heat_meter/manage',
        method: 'POST',
        data
    })
}

// 设备点位-删除
export const deleteDevice = (id) => {
    return request({
        url: `/HVAC/heat_meter/${id}`,
        method: 'DELETE'
    })
}
// 获取点位设备列表
export const getDeviceListReport = (data) => {
    return request({
        url: '/HVAC/heat_meter/report_data',
        params: data
    })
}
